module.exports = __webpack_public_path__ + "img/horizontal_3_2_r_pp2_9016.22fcd887.png";